import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { format } from 'date-fns';

const RetroReport = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const tableRef = useRef(null);
  const footerTotalsRef = useRef({
    quantity: '0.00',
    line_total: '0.00',
    retro: '0.00',
    prompt_payment: '0.00',
    cost_to_serve: '0.00',
    off_invoice: '0.00',
    beds_leds: '0.00',
    sugro_retro: '0.00',
    total_discount: '0.00',
  });

  const setFooterTotals = (totals = {}) => {
    const values = {
      quantity: totals.quantity ?? '0.00',
      line_total: totals.line_total ?? '0.00',
      retro: totals.retro ?? '0.00',
      prompt_payment: totals.prompt_payment ?? '0.00',
      cost_to_serve: totals.cost_to_serve ?? '0.00',
      off_invoice: totals.off_invoice ?? '0.00',
      beds_leds: totals.beds_leds ?? '0.00',
      sugro_retro: totals.sugro_retro ?? '0.00',
      total_discount: totals.total_discount ?? '0.00',
    };
    footerTotalsRef.current = values;
    $('#retro-foot-qty').text(values.quantity);
    $('#retro-foot-line-total').text(values.line_total);
    $('#retro-foot-retro').text(values.retro);
    $('#retro-foot-prompt').text(values.prompt_payment);
    $('#retro-foot-cost-serve').text(values.cost_to_serve);
    $('#retro-foot-off-invoice').text(values.off_invoice);
    $('#retro-foot-beds-leds').text(values.beds_leds);
    $('#retro-foot-sugro-retro').text(values.sugro_retro);
    $('#retro-foot-total-discount').text(values.total_discount);
  };

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      setFromDate(format(start, 'yyyy-MM-dd'));
      setToDate(format(end, 'yyyy-MM-dd'));
    } else {
      setFromDate('');
      setToDate('');
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }

    const $table = $(tableRef.current);
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }

    const table = $table.DataTable({
      serverSide: true,
      processing: true,
      ajax: {
        url: `${config.api_url}/ws-retro-report-list`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: (d) => ({
          ...d,
          searchByFromdate: fromDate,
          searchByTodate: toDate,
          searchValue,
        }),
        dataSrc: (json) => {
          setFooterTotals(json?.totals || {});
          return Array.isArray(json?.data) ? json.data : [];
        },
      },
      columns: [
        { data: 'created_date' },
        { data: 'reference_no' },
        { data: 'supplier_name' },
        { data: 'code' },
        { data: 'product_desc' },
        { data: 'quantity', className: 'text-end' },
        { data: 'cost', className: 'text-end' },
        { data: 'line_total', className: 'text-end' },
        { data: 'retro', className: 'text-end' },
        { data: 'prompt_payment', className: 'text-end' },
        { data: 'cost_to_serve', className: 'text-end' },
        { data: 'off_invoice', className: 'text-end' },
        { data: 'beds_leds', className: 'text-end' },
        { data: 'sugro_retro', className: 'text-end' },
        { data: 'total_discount', className: 'text-end' },
      ],
      pageLength: 50,
      lengthMenu: [10, 25, 50, 100],
      ordering: false,
      scrollX: true,
      drawCallback: () => {
        setFooterTotals(footerTotalsRef.current);
      },
    });

    return () => {
      table.destroy();
    };
  }, [fromDate, toDate, searchValue]);

  return (
    <div>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Link to="/Dashboard"><i className="fa fa-home" /></Link> &gt;
              <Link to="/Dashboard">Dashboard</Link> &gt;
              <span className="last-crumb">Retro Report</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="dashboard">
                <div className="topsearch-area retro-report-filters">
                  <div className="row g-2 g-lg-3 align-items-end">
                    <div className="col-lg-5 col-md-6">
                      <div className="row mb-2">
                        <label className="col-sm-4 col-form-label">Search</label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="search-area form-control"
                            placeholder="PO, supplier, product..."
                            autoComplete="off"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="row mb-2">
                        <label className="col-sm-3 col-form-label">Date Range</label>
                        <div className="col-sm-9">
                          <DateRangePicker
                            value={[fromDate ? new Date(fromDate) : null, toDate ? new Date(toDate) : null]}
                            onChange={handleDateChange}
                            format="dd/MM/yyyy"
                            editable={false}
                            placeholder="DD/MM/YYYY - DD/MM/YYYY"
                            cleanable
                            style={{ width: '100%' }}
                            onClean={() => {
                              setFromDate('');
                              setToDate('');
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="common-table retro-report-table-wrap">
                  <table className="table table-bordered dataTable" id="retroReportTable" ref={tableRef}>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>P.O ID</th>
                        <th>Supplier</th>
                        <th>Code</th>
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Cost</th>
                        <th>Line Total</th>
                        <th>Retro</th>
                        <th>Prompt Pay</th>
                        <th>Cost To Serve</th>
                        <th>Off Invoice</th>
                        <th>Beds/Leds</th>
                        <th>Sugro Retro</th>
                        <th>Total Discount</th>
                      </tr>
                    </thead>
                    <tbody />
                    <tfoot>
                      <tr>
                        <th colSpan="5" className="text-end">Total</th>
                        <th className="text-end" id="retro-foot-qty">0.00</th>
                        <th className="text-end" />
                        <th className="text-end" id="retro-foot-line-total">0.00</th>
                        <th className="text-end" id="retro-foot-retro">0.00</th>
                        <th className="text-end" id="retro-foot-prompt">0.00</th>
                        <th className="text-end" id="retro-foot-cost-serve">0.00</th>
                        <th className="text-end" id="retro-foot-off-invoice">0.00</th>
                        <th className="text-end" id="retro-foot-beds-leds">0.00</th>
                        <th className="text-end" id="retro-foot-sugro-retro">0.00</th>
                        <th className="text-end" id="retro-foot-total-discount">0.00</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RetroReport;
